<template><div>
  <h1 class="fdd-md--h1">fd-context-button</h1>
<p class="fdd-md--p">Context button component – should be used together with <d-component-api-link type="prominent" component-name="fd-context-menu"></d-component-api-link>. This component extends <d-component-api-link type="prominent" component-name="fd-button"></d-component-api-link>. Thus is can use used just like any other <d-component-api-link type="prominent" component-name="fd-button"></d-component-api-link>. It simply comes with a different set of defaults.</p>
<h2 class="fdd-md--h2">Props</h2>
<h3 class="fdd-md--h3">styling</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>not specified</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>light</code></p>
<h3 class="fdd-md--h3">icon</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>not specified</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>overflow</code></p>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":["Context button component – should be used together with `fd-context-menu`. This component extends `fd-button`. Thus is can use used just like any other `fd-button`. It simply comes with a different set of defaults."]},"name":"fd-context-button","props":[{"name":"styling","type":null,"describe":[],"default":"light"},{"name":"icon","type":null,"describe":[],"default":"overflow"}],"slots":[]}
  };
 }
}
]
  }
  </script>
  